import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './treksMain.scss';
import { HiOutlineLocationMarker } from 'react-icons/hi';
import { Helmet } from 'react-helmet';
import { getTripsByCategory } from '../services/tripServices';
import { IMAGE_BASE_URL } from '../config';
import { FaStar } from 'react-icons/fa';

const TreksMain = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    getTripsByCategory('Challenging-treks')
      .then((trips) => {
        setData(trips);
      })
      .catch((error) => {
        console.error('Error fetching latest treks:', error);
      });
  }, []);

  return (
    <section className='main container section'>
      <Helmet>
        <title>World Adventures Tours</title>
        <meta
          name="description"
          content="Explore the most visited travel destinations in Pakistan including K2 Base Camp trek, K2 Gandogoro La Trek, Hunza Valley, Nanga Parbat, and more. Book your next adventure with us!"
        />
      </Helmet>

      <div className="secTitle">
        <center><h3>Explore Our Signature Treks</h3></center>
      </div>

      {/* ✅ GRID SECTION (No Slider) */}
      <div className="cardsGrid">
        {data.length > 0 ? (
          data.map((item) => (
            <div className="tourcard" key={item.id}>

              {/* IMAGE */}
              <div className="cardImage">
                <img
                  crossOrigin='anonymous'
                  src={`${IMAGE_BASE_URL}/${item.image}`}
                  alt={item.title}
                />

                <div className="imageBadges">
                  <span className="badge">
                    <HiOutlineLocationMarker /> {item.location}
                  </span>
                  <span className="badge">{item.days}</span>
                </div>
              </div>

              {/* BODY */}
              <div className="cardBody">
                <h3 className="destTitle">{item.title}</h3>

                <div className="reviews">
                  <div className="stars">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} />
                    ))}
                  </div>
                  <span className="reviewsText">Based on {item.reviewsCount} reviews</span>
                </div>


                <p className="desc">{item.description}</p>

                <div className="cardFooter">
                  <span className="price">${item.price}</span>
                  <Link to={`/${item.slug}`} className="detailsBtn">
                    Details
                  </Link>
                </div>
              </div>

            </div>
          ))
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </section>
  );
};

export default TreksMain;
